/* tslint:disable */
/* eslint-disable */
/**
 * DUPR Backend APIs (Internal)
 * Internal RESTful APIs to access DUPR ratings, users and provide matches.
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../base';
// @ts-ignore
import type { ResultFeatureUsageResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { UserActionRequiredResponse } from '../../../commons/generated/model';
/**
 * FeatureUsageApi - axios parameter creator
 * @export
 */
export const FeatureUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Informational only — this endpoint never blocks. Features the user has no grant for are included with a no-grant status so clients can render upsells.
         * @summary This user\'s usage across every feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/features/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Spends one slot of the named ACTIVE_SET feature to hold {resourceId}. Idempotent (re-unlocking a held resource never re-charges); exempt for your own resource; a full set returns unlocked=false with the held ids. Usage-count features are rejected.
         * @summary Unlock (hold) a resource against a set quota
         * @param {string} featureKey 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlock: async (featureKey: string, resourceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureKey' is not null or undefined
            assertParamExists('unlock', 'featureKey', featureKey)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('unlock', 'resourceId', resourceId)
            const localVarPath = `/api/features/{featureKey}/unlock/{resourceId}`
                .replace(`{${"featureKey"}}`, encodeURIComponent(String(featureKey)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureUsageApi - functional programming interface
 * @export
 */
export const FeatureUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * Informational only — this endpoint never blocks. Features the user has no grant for are included with a no-grant status so clients can render upsells.
         * @summary This user\'s usage across every feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultFeatureUsageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureUsageApi.getUsage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Spends one slot of the named ACTIVE_SET feature to hold {resourceId}. Idempotent (re-unlocking a held resource never re-charges); exempt for your own resource; a full set returns unlocked=false with the held ids. Usage-count features are rejected.
         * @summary Unlock (hold) a resource against a set quota
         * @param {string} featureKey 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlock(featureKey: string, resourceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlock(featureKey, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureUsageApi.unlock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureUsageApi - factory interface
 * @export
 */
export const FeatureUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureUsageApiFp(configuration)
    return {
        /**
         * Informational only — this endpoint never blocks. Features the user has no grant for are included with a no-grant status so clients can render upsells.
         * @summary This user\'s usage across every feature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(options?: RawAxiosRequestConfig): AxiosPromise<ResultFeatureUsageResponse> {
            return localVarFp.getUsage(options).then((request) => request(axios, basePath));
        },
        /**
         * Spends one slot of the named ACTIVE_SET feature to hold {resourceId}. Idempotent (re-unlocking a held resource never re-charges); exempt for your own resource; a full set returns unlocked=false with the held ids. Usage-count features are rejected.
         * @summary Unlock (hold) a resource against a set quota
         * @param {string} featureKey 
         * @param {string} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlock(featureKey: string, resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.unlock(featureKey, resourceId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureUsageApi - interface
 * @export
 * @interface FeatureUsageApi
 */
export interface FeatureUsageApiInterface {
    /**
     * Informational only — this endpoint never blocks. Features the user has no grant for are included with a no-grant status so clients can render upsells.
     * @summary This user\'s usage across every feature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureUsageApiInterface
     */
    getUsage(options?: RawAxiosRequestConfig): AxiosPromise<ResultFeatureUsageResponse>;

    /**
     * Spends one slot of the named ACTIVE_SET feature to hold {resourceId}. Idempotent (re-unlocking a held resource never re-charges); exempt for your own resource; a full set returns unlocked=false with the held ids. Usage-count features are rejected.
     * @summary Unlock (hold) a resource against a set quota
     * @param {string} featureKey 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureUsageApiInterface
     */
    unlock(featureKey: string, resourceId: string, options?: RawAxiosRequestConfig): AxiosPromise<object>;

}

/**
 * FeatureUsageApi - object-oriented interface
 * @export
 * @class FeatureUsageApi
 * @extends {BaseAPI}
 */
export class FeatureUsageApi extends BaseAPI implements FeatureUsageApiInterface {
    /**
     * Informational only — this endpoint never blocks. Features the user has no grant for are included with a no-grant status so clients can render upsells.
     * @summary This user\'s usage across every feature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureUsageApi
     */
    public getUsage(options?: RawAxiosRequestConfig) {
        return FeatureUsageApiFp(this.configuration).getUsage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Spends one slot of the named ACTIVE_SET feature to hold {resourceId}. Idempotent (re-unlocking a held resource never re-charges); exempt for your own resource; a full set returns unlocked=false with the held ids. Usage-count features are rejected.
     * @summary Unlock (hold) a resource against a set quota
     * @param {string} featureKey 
     * @param {string} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureUsageApi
     */
    public unlock(featureKey: string, resourceId: string, options?: RawAxiosRequestConfig) {
        return FeatureUsageApiFp(this.configuration).unlock(featureKey, resourceId, options).then((request) => request(this.axios, this.basePath));
    }
}

